// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2iBT0","approved":"Status_approved__2vLuS","rejected":"Status_rejected__1JiY2","expired":"Status_expired__FmF8a","label":"Status_label__1CVuU"};